import { LONG_HAND_RATE_FORMAT } from '../services/RateFormatServiceFactory';
import { MultipleRateFormatter } from '../formatters/MultipleRateFormatter';

const RatesKeyCreator = ({ value, context }) => {
    return MultipleRateFormatter({
        value,
        data: { datasetId: context?.datasetId },
        context: { rateFormat: LONG_HAND_RATE_FORMAT },
    });
};

export default RatesKeyCreator;
